import ApiService from "../../services/ApiService";

class FileModalService {
  constructor() {
    this.isOpen = false;
    this.files = [];
    this.listeners = new Set();
  }

  subscribe = (listener) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  notify = () => {
    this.listeners.forEach((listener) => listener(this.isOpen));
  };

  showFilesModal = () => {
    this.isOpen = true;
    this.notify();
  };

  hideFilesModal = () => {
    this.isOpen = false;
    this.notify();
  };

  getFiles = () => {
    return this.files;
  };

  loadFiles = async (userId) => {
    try {
      const files = await ApiService.awaitRequest(
        {},
        `users/${userId}/files`,
        "get"
      );
      console.log("files", files);
      this.files = files;
      return files;
    } catch (error) {
      console.error("Error loading files:", error);
      return [];
    }
  };

  downloadFile = async (userId, fileName) => {
    try {
      const zipFile = await ApiService.awaitRequest(
        {},
        `users/${userId}/files/download/${fileName}`,
        "get",
        "",
        "",
        "blob"
      );

      const url = window.URL.createObjectURL(
        new Blob([zipFile], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);

      return true;
    } catch (error) {
      console.error("Error downloading file:", error);
      throw error;
    }
  };

  getIsOpen = () => {
    return this.isOpen;
  };
}

export const fileModalService = new FileModalService();
